export const DeviceTypes = ['web_mobile', 'desktop'] as const;
export type DeviceType = (typeof DeviceTypes)[number];

type NavigatorUA = Navigator & { userAgentData?: { mobile?: boolean } };

export const detectDeviceType = (): DeviceType => {
  const nav = (globalThis as { navigator?: NavigatorUA }).navigator;
  const uaDataMobile = nav?.userAgentData?.mobile === true;
  const uaMobile =
    !!nav &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      nav.userAgent,
    );
  return uaDataMobile || uaMobile ? 'web_mobile' : 'desktop';
};
